module.exports = __webpack_public_path__ + "static/media/titraus.d9eae717.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./media/photos/titraus.jpg
 ** module id = 421
 ** module chunks = 0
 **/